import { Dashboard } from '../../Dashboard/Dashboard';

export const Home = () => {
  return <Dashboard />;
};
